export default __webpack_public_path__ + "static/media/fire.3cf68792.svg";